import { useQuery } from "react-query";
import { getActiveTexasGrouping } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetActiveTexasGrouping = () => {
  return useQuery("GetActiveTexasGrouping", getActiveTexasGrouping, {
    refetchOnWindowFocus: false,
  });
};
